module.exports = __webpack_public_path__ + "img/Illustration-Error-404.d32ba363.svg";